import type { PlatformName } from '../api/types.js';

/**
 * Which platforms emit each event, mirrored for the Console bundle.
 *
 * GENERATED from `EVENT_EMISSION` in platform-core, which is itself checked
 * against the adapter source by `event-emission.test.ts`. The Console does not
 * depend on that package, and a second hand-written copy would be a claim that
 * drifts — so this one is derived and asserted equal in
 * `event-emission.test.ts` on this side too.
 */
export type EmissionRow = {
  event: string;
  label: string;
  emittedBy: PlatformName[];
  note: string;
};

export const EMISSION_ROWS: EmissionRow[] = [
  {
    event: 'chat.message',
    label: 'Chat messages',
    emittedBy: ['twitch', 'youtube', 'kick', 'blaze', 'discord', 'rumble'],
    note: 'Every connected platform.',
  },
  {
    event: 'subscription',
    label: 'Subscriptions',
    emittedBy: ['twitch'],
    note: 'Twitch new subs and resubs. Kick publishes no subscription events to Connaro.',
  },
  {
    event: 'gift',
    label: 'Gifted subscriptions',
    emittedBy: ['twitch', 'youtube'],
    note: 'Twitch gift subs and YouTube gifted memberships.',
  },
  {
    event: 'donation',
    label: 'Bits, Super Chats and tips',
    emittedBy: ['twitch', 'youtube', 'rumble'],
    note: 'Twitch bits, YouTube Super Chat and Super Stickers, Rumble Rants.',
  },
  {
    event: 'raid',
    label: 'Raids',
    emittedBy: ['twitch'],
    note: 'Raids arriving at your channel.',
  },
  {
    event: 'follow',
    label: 'Follows',
    emittedBy: ['rumble'],
    note: 'Rumble only. Twitch follows need a scope Connaro does not request.',
  },
  {
    event: 'membership',
    label: 'Memberships',
    emittedBy: ['youtube'],
    note: 'YouTube new members and member milestones.',
  },
  {
    event: 'chat.deleted',
    label: 'Deleted messages',
    emittedBy: ['youtube'],
    note: 'YouTube reports deletions; other platforms do not.',
  },
  {
    event: 'system',
    label: 'Stream and channel notices',
    emittedBy: ['youtube', 'rumble'],
    note: 'Stream ended, sponsor-only mode, and similar.',
  },
];
